import React, { useState, useEffect, useLayoutEffect } from "react";
// import "./BasicProjects.css";
import { useHistory } from "react-router-dom";
import { Link } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
// import Grid from '@material-ui/core/Grid';
import { Auth } from "aws-amplify";
import { Grid, Typography } from "@material-ui/core";

import Button from "@material-ui/core/Button";
import ListIcon from "@material-ui/icons/List";
import GridView from "@material-ui/icons/GridOn";
import DeleteIcon from "@material-ui/icons/Delete";

import S3 from "react-aws-s3";

import {
  listEduvanceAITools,
  getEduvanceAiUsers,
  listEduvanceAiUsers,
} from "../../graphql/queries";
import { deleteEduvanceAITool } from "../../graphql/mutations";
import { API } from "aws-amplify";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import AddIcon from "@material-ui/icons/Add";

import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import TextField from "@material-ui/core/TextField";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    position: "absolute",
    // width: '60vw',
    backgroundColor: "#a0a0a0",
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));

const MultiConfigProjectView2 = (props) => {
  const [listview, setListView] = useState(true);
  const classes = useStyles();
  let history = useHistory();

  const config = {
    bucketName: "eduvancewebai",
    dirName:
      "projects/" +
      localStorage.getItem(
        "CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser",
      ) /* optional */,
    region: "ap-south-1",
    accessKeyId: "AKIA3AQTRT6P7J7N3JUJ",
    secretAccessKey: "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",
  };
  const ReactS3Client = new S3(config);

  const [couponModalOpen, setCouponModalOpen] = useState(false);
  const [basicProjects, setBasicProjects] = useState("");

  useEffect(() => {
    fetchProjects();
  }, []);

  async function fetchProjects() {
    let nexttoken = "";
    let basicArray = [];

    while (nexttoken !== null) {
      const apiData = await API.graphql({
        query: listEduvanceAITools,
        variables: {
          filter: {
            user: {
              eq: localStorage.getItem(
                "CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser",
              ),
            },
            projectType: { eq: "Intermediate" },
          },
          limit: 1000,
          nextToken: nexttoken,
        },
      });
      // const apiData = await API.graphql({ query: getEduvanceALToolByUser, variables:{user:"swapbawa"} });
      // console.log("data " + apiData.data.listEduvanceAITools.items);

      nexttoken = apiData.data.listEduvanceAITools.nextToken;
      apiData.data.listEduvanceAITools.items.forEach((item) => {
        basicArray.push(item);
      });
      // basicArray.push(apiData.data.listEduvanceAITools.items);
    }

    setBasicProjects(basicArray);
  }

  const handlecouponModalOpen = () => {
    setCouponModalOpen(true);
  };

  const handleCouponModalClose = () => {
    setCouponModalOpen(false);
  };
  async function signOut() {
    try {
      await Auth.signOut({ global: true });
      window.location.reload();
    } catch (error) {
      // console.log('error signing out: ', error);
    }
  }
  const verifyCoupon = () => {
    var couponid = document.getElementById("couponid").value;
    var username = localStorage.getItem(
      "CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser",
    );
    var userdata = localStorage.getItem(
      `CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.${username}.userData`,
    );
    var jsondata = JSON.parse(userdata);
    var data = `${username}//${jsondata["UserAttributes"][jsondata["UserAttributes"].length - 2]["Value"]}`;
    var xhr = new XMLHttpRequest();
    xhr.addEventListener("readystatechange", function () {
      if (this.readyState === 4) {
        if (this.responseText === "Coupon successfully redeemed") {
          alert("coupon successfully redeemed");
          setCouponModalOpen(false);
          // window.location.reload();
        } else alert(this.responseText);
      }
    });
    xhr.open(
      "POST",
      `https://s2v68e8y9a.execute-api.ap-south-1.amazonaws.com/dev/coupon?coupon=${couponid}&type=redeem`,
    );
    xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
    xhr.send(data);
  };

  async function deleteProject(e) {
    let projectid = e; //e.currentTarget.id.substring(3);
    console.log("eeeee " + e);
    let files = ["model.pkl", "config.json", "cnn.h5", "cnn.json"];
    files.forEach(function (item, index) {
      console.log("fiels " + projectid + "_" + item);
      try {
        ReactS3Client.deleteFile(`${projectid}_${item}`)
          .then((response) => console.log(response))
          .catch((err) => console.error(err));
      } catch {
        console.log("file not found");
      }
    });
    // console.log("clicke "+ projectid );
    await API.graphql({
      query: deleteEduvanceAITool,
      variables: {
        input: {
          projectname:
            localStorage.getItem(
              "CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser",
            ) +
            "//Intermediate//" +
            projectid,
        },
      },
    });

    fetchProjects();
  }

  const viewProject = (e) => {
    let plink = e.currentTarget.id.substring(4);
    // console.log("clicke "+ e.currentTarget.id.substring(4));
    history.push(
      `/intermediateproject/${localStorage.getItem("CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser")}/${plink}`,
    );
  };

  return (
    <>
      {/* <div className="mainbodybasic">
            </div> */}
      <Modal
        open={couponModalOpen}
        onClose={handleCouponModalClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        className={classes.modal}
        BackdropComponent={Backdrop}
      >
        <div className={classes.paper + " text-center"}>
          <TextField
            id="couponid"
            style={{ width: "11rem" }}
            placeholder="Enter Coupon"
          />
          <br></br>
          <br></br>
          <span>Please mail at contact@eduvance.in to get coupon.</span>
          <Button
            variant="contained"
            color="primary"
            component="span"
            onClick={verifyCoupon}
          >
            SUBMIT
          </Button>
        </div>
      </Modal>
      <div>
        <img
          id="backgroundmainimageoverlay"
          src="/assets/images/background/g7.mp4"
          style={{
            filter: "opacity(0.2)",
            position: "fixed",
            zIndex: "-3",
            width: "100vw",
            height: "110vh",
            marginTop: "-10vh",
            overflow: "hidden",
          }}
        />
        <img
          style={{ zIndex: "-4" }}
          id="backgroundmainimage"
          src="/assets/images/background/MainBackground.png"
        />
      </div>
      <div className="container-fluid navcontent">
        <div className="row justify-content-between">
          <div className="col-auto align-self-end">
            <div>
              <Grid
                style={{ display: "flex", position: "relative", zIndex: "4" }}
              >
                <Link to="/">
                  <Button variant="contained" component="span" color="primary">
                    Back
                  </Button>
                </Link>
                {/* <AccountCircleIcon style={{marginLeft:"1vw"}} /> */}
                {/* {localStorage.getItem("accountType")==="Premium"?
                                <>
                                <Typography style={{paddingRight:"1vw",paddingTop:"2vh",paddingLeft:"2vw",fontSize:"1.5vw"}}>Premium User</Typography>
                                <Typography style={{fontSize:"1.5vw",paddingTop:"2vh"}} >Validity:{localStorage.getItem("validity").substring(3,16)}</Typography>
                                </>
                                :
                                <>
                                <Typography style={{paddingLeft:"2vw",paddingTop:"2vh",paddingRight:"8vw",fontSize:"1.5vw"}}>Free User</Typography>                          
                                <a href="#" onClick={()=>{setCouponModalOpen(true)}} style={{paddingTop:"0.5vh",paddingLeft:"5vw",fontSize:"2vw"}}>+</a>
                                </>
                                } */}
              </Grid>
            </div>
          </div>
          <div className="col-auto align-self-end basicheader">
            <h2 style={{ paddingTop: "10vh !important" }}>Intermediate</h2>
          </div>
          <div className="col-auto align-self-end">
            {/* <Link to="/" style={{paddingRight:"2vw"}}>
                                <Button  variant="contained" color="primary" >Home</Button>
                            </Link> */}
            <Button
              style={{
                backgroundColor: "#ffa502",
                position: "relative",
                zIndex: "4",
              }}
              variant="contained"
              onClick={() => {
                signOut();
              }}
              color="primary"
              component="span"
            >
              Sign Out
            </Button>
          </div>
        </div>
      </div>
      {/**************************** projects list starts from here  ****************/}

      <div className="project-list-container">
        <div className="project-list-header">
          <h3>My Projects</h3>
          <div style={{ display: "flex", alignItems: "start" }}>
            <Link to="/intermediatenew" style={{ textDecoration: "none" }}>
              <p className="createnewbtn">Create New</p>
            </Link>
            <div style={{ padding: "0 1rem" }}>
              <ListIcon
                onClick={() => setListView(true)}
                style={
                  listview
                    ? {
                        background: "#222",
                        outline: "1px solid #222",
                        padding: "0.5rem",
                        width: "2.5rem",
                        height: "2.5rem",
                        borderRadius: "0.5rem",
                        cursor: "pointer",
                      }
                    : {
                        outline: "1px solid #222",
                        padding: "0.5rem",
                        width: "2.5rem",
                        height: "2.5rem",
                        borderRadius: "0.5rem",
                        cursor: "pointer",
                      }
                }
              />
              <GridView
                onClick={() => setListView(false)}
                style={
                  !listview
                    ? {
                        background: "#222",
                        outline: "1px solid #222",
                        padding: "0.5rem",
                        width: "2.5rem",
                        height: "2.5rem",
                        borderRadius: "0.5rem",
                        cursor: "pointer",
                      }
                    : {
                        outline: "1px solid #222",
                        padding: "0.5rem",
                        width: "2.5rem",
                        height: "2.5rem",
                        borderRadius: "0.5rem",
                        cursor: "pointer",
                      }
                }
              />
            </div>
          </div>
        </div>

        <div
          className="project-card-list"
          style={
            listview ? { flexDirection: "column" } : { flexDirection: "row" }
          }
        >
          {basicProjects === "" ? (
            <>
              <div className="container selectcontainer">
                <div className="row justify-content-md-center">
                  <div className="col-4 " style={{ paddingLeft: "5vw" }}>
                    <h4>No Projects</h4>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <>
              {basicProjects.map((item) => (
                <>
                  {item["projectname"].split("//")[2] !== "untitled" ? (
                    <div
                      key={item["projectname"].split("//")[2]}
                      className="project-card"
                      style={listview ? { width: "100%" } : { width: "15rem" }}
                    >
                      <h4
                        style={
                          listview
                            ? { fontSize: "1.5rem", paddingTop: "1.5rem" }
                            : { fontSize: "1.2rem", paddingTop: "1.5rem" }
                        }
                      >
                        {item["projectname"].split("//")[2]}
                      </h4>

                      <div className="project-btns">
                        <div
                          className="view btns"
                          id={`view${item["projectname"].split("//")[2]}`}
                          onClick={viewProject}
                        >
                          <span>View</span>
                        </div>

                        <div
                          className="delete btns"
                          id={`del${item["projectname"].split("//")[2]}`}
                          onClick={() => {
                            deleteProject(item["projectname"].split("//")[2]);
                          }}
                        >
                          <DeleteIcon />
                        </div>
                      </div>
                    </div>
                  ) : (
                    <></>
                  )}
                </>
              ))}
            </>
          )}
        </div>
      </div>

      {/* </div> */}
      {/* </div> */}
    </>
  );
};

export default MultiConfigProjectView2;
